import { buildQueryString, parseQueryString } from '../utils/queryString.js';
export function buildPlaygroundQueryString(params) {
    return buildQueryString(encodePlaygroundSearchParams(params));
}
export function parsePlaygroundQueryString(query) {
    return decodePlaygroundSearchParams(parseQueryString(query));
}
function encodePlaygroundSearchParams(params) {
    const stringParams = {};
    if (params.fixture) {
        stringParams.fixture = JSON.stringify(params.fixture);
    }
    return stringParams;
}
function decodePlaygroundSearchParams(stringParams) {
    const params = {};
    if (stringParams.fixture) {
        params.fixture = JSON.parse(stringParams.fixture);
    }
    return params;
}
